import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Auth strategy: httpOnly cookies (`access_token`, `refresh_token`) set by the
 * backend on /auth/login and /auth/register. The frontend NEVER touches tokens
 * — no localStorage, no sessionStorage — which mitigates XSS token theft.
 *
 * `withCredentials: true` ensures axios attaches the cookies to every request
 * to the API origin.
 */
const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
